export const ComparatorType = {
    EQUALS : 1,
    GREATER_THAN_EQUALS : 2,
    LESS_THAN_EQUALS : 3
};
